const umlauteErsetzen = (text = '') => {
  text=text.replace(/\u00c4/g,"Ae")
  text=text.replace(/A\u0308/g,"Ae")
  text=text.replace(/\u00e4/g,"ae")
  text=text.replace(/a\u0308/g,"ae")

  text=text.replace(/\u00d6/g,"Oe")
  text=text.replace(/\u00f6/g,"oe")
  text=text.replace(/o\u0308/g,"oe")
  text=text.replace(/O\u0308/g,"Oe")

  text=text.replace(/\u00dc/g,"Ue")
  text=text.replace(/\u00fc/g,"ue")
  text=text.replace(/u\u0308/g,"ue")
  text=text.replace(/U\u0308/g,"Ue")
  return(text)
}


export default umlauteErsetzen;